export default {
  precision: 'Precision'
}
